import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 0.7, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          whileHover={{ opacity: 1, scale: 1.08 }}
          transition={{ duration: 0.2 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-24 right-4 md:bottom-8 md:right-6 z-[9970] w-10 h-10 flex items-center justify-center bg-[#0A1628]/80 hover:bg-[#3B9EE8] text-white rounded-full cursor-pointer transition-colors duration-200 border border-white/15 backdrop-blur-md"
          aria-label="Terug naar boven"
        >
          <i className="ri-arrow-up-line text-sm" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}